import React from 'react';
import i18n from '../../i18n';
import { Car } from 'lucide-react';
import Lightbox from 'react-awesome-lightbox';
import Countdown from 'react-countdown';
import HeaderRowGrp from '../helpers/headerRowGrp';
import { AuctionCard } from './helpers/auctionCard';
import { CustomEnroll } from '../helpers/customEnroll';
import { getCategories } from '../../models/categories';
import { getGroupedAuctions } from '../../models/auctions';
import { AuctionListGrouped } from '../helpers/skeletons/AuctionListGrouped';
import { AuctionRowGrouped } from './helpers/auctionRowGrouped';
import { getOrganizations } from '../../models/organization';
import DatePicker from 'react-date-picker';
import { baseUrl } from '../../constants/global';
import { HomeBanner } from './homeBanner';

const CalendarIcon = () => {
  return (
    <span className="date-icon">
      <i className="mdi mdi-calendar text-success" />
    </span>
  );
};

const ClearIcon = () => {
  return <fa className="mdi mdi-close" />;
};

const FinishBid = () => <span className="text-danger">{i18n.t('time_ends')}</span>;

const renderer = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    return <FinishBid />;
  } else {
    let warning = days === 0 && hours === 0 && minutes === 0 && seconds < 10 ? true : false;
    return (
      <span
        className={
          warning
            ? 'text-danger countdown-listing-pg countdwn-warning'
            : 'text-info countdown-listing-pg'
        }
      >
        {days}
        {i18n.t('D')} : {hours}
        {i18n.t('H')} : {minutes}
        {i18n.t('M')} : {seconds}
        {i18n.t('S')}
      </span>
    );
  }
};

//const user = getLoggedUser();
let is_logged = localStorage.getItem('is_logged_in') ? true : false;
let lng = localStorage.getItem('I18N_LANGUAGE');
let group_limit = localStorage.getItem('group_limit');

export class AuctionsListGrouped extends React.Component {
  constructor() {
    super();
    let path = window.location.pathname;
    let groupID = path.substring(path.lastIndexOf('/') + 1, path.length);

    let urlParams = new URLSearchParams(window.location.search);
    let param1Value = urlParams.get('type');

    this.state = {
      section: 'main',
      catArrs: [],
      page_type: param1Value,
      categories: [],
      input: {
        auction: '',
        fdate: '',
        tdate: '',
        organization: '',
      },
      organizations: [],
      auctions: {},
      limit: 30,
      meta: {},
      loading: false,
      group: groupID,
      gpData: {},
      orgData: {},
      enrolledUsers: 0,
      lightboxImages: [],
      is_active_light_box: false,
      now: () => {
        let time = new Date().toLocaleTimeString('en-US', {
          timeZone: 'Asia/Riyadh',
        });
        let dt = new Date().toISOString('en-US').split('T')[0];
        let newDt = dt + ' ' + time;
        newDt = new Date(newDt.replace(/-/g, '/'));
        return newDt;
      },
      show_filter_pop: false,
      fdate: '',
      tdate: '',
      grid: false,
      show_cat_dd: false,
      isOpen: false,
      selectedCategories: [],
      selectedVehicleTypes: [],
      selectedMakes: [],
      selectedModels: [],
      searchTerm: '',
      vehicleTypeSearch: '',
      priceRange: { min: '', max: '' },
      yearRange: { min: '', max: '' },
      odometer: { min: '', max: '' },
      endDate: '',
      expandedSections: {
        category: true,
        vehicleType: true,
        make: false,
        model: false,
        endDate: false,
        odometer: false,
        priceRange: false,
        yearRange: false,
      },
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.loadGroupedAuctions = this.loadGroupedAuctions.bind(this);
    this.getImagePopup = this.getImagePopup.bind(this);
    this.searchAuctions = this.searchAuctions.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
    this.createCategory = this.createCategory.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    let urlSearchParams = new URLSearchParams(window.location.search);
    let params = Object.fromEntries(urlSearchParams.entries());
    let lt = group_limit || 30;
    this.loadGroupedAuctions({ limit: lt });
    this.loadAllCategories(params);
    this.loadAllOrganizations(params);
  }

  async loadAllOrganizations(params) {
    this.setState({ is_org_loading: true });
    if (typeof params.organization !== 'undefined') {
      var org = params.organization;
      this.setState({ orgArrs: [parseInt(org)] });
    }
    const response = await getOrganizations();
    if (response) {
      let organizations = response.data;
      this.setState({ organizations });
      this.setState({ is_org_loading: false });
    }
  }

  async loadAllCategories(params) {
    this.setState({ is_cat_loading: true });
    if (typeof params.category !== 'undefined') {
      var category = params.category;
      this.setState({ catArrs: [parseInt(category)] });
    }
    const response = await getCategories();
    if (response) {
      let categories = response.data;
      this.setState({ categories });
      this.setState({ is_cat_loading: false });
    }
  }

  handleDateChange(date, type) {
    let input = this.state.input;
    if (type === 'fdate') {
      input.fdate = date;
      this.setState({ fdate: date });
    }
    if (type === 'tdate') {
      input.tdate = date;
      this.setState({ tdate: date });
    }
    this.setState({ input });
  }

  createCategory(id, sub = false) {
    if (sub) {
      var subCatArrs = this.state.catArrs;
      if (subCatArrs.includes(id)) {
        const index = subCatArrs.indexOf(parseInt(id));
        if (index > -1) {
          subCatArrs.splice(index, 1);
        }
      } else {
        subCatArrs.push(parseInt(id));
      }
      this.setState({ subCatArrs: subCatArrs });
      this.applyFilters();
    } else {
      if (!id) {
        this.setState({ catArrs: [] });
        this.applyFilters();
        return;
      }
      var catArrs = this.state.catArrs;
      if (catArrs.includes(id)) {
        const index = catArrs.indexOf(parseInt(id));
        if (index > -1) {
          catArrs.splice(index, 1);
        }
      } else {
        catArrs.push(parseInt(id));
      }
      this.setState({ catArrs: catArrs });
      this.applyFilters();
    }
  }

  applyFilters() {
    var type = this.state.type;
    var section = this.state.section;
    var catArrs = this.state.catArrs;
    var cats = catArrs.join(',');
    if (catArrs.length < 1) {
      cats = '';
    }

    this.setState({
      category: cats,
      type: type,
      section: section,
    });

    this.loadGroupedAuctions({
      sec: section,
      type: type,
      category: cats,
    });
  }

  handleChange(event) {
    let input = this.state.input;
    input[event.target.name] = event.target.value;
    this.setState({ input });
  }

  async loadGroupedAuctions(params) {
    localStorage.setItem('group_limit', params.limit);
    this.setState({ limit: params.limit });
    let { group } = this.state;
    let q = '';
    if (group) {
      q += 'group=' + group;
    }
    if (!isNaN(params.limit)) {
      q += '&limit=' + params.limit;
    }
    if (typeof params.category !== 'undefined') {
      q += '&category=' + params.category;
    }

    this.setState({ loading: true });
    const response = await getGroupedAuctions(q);
    let auctions = response.data;
    let meta = response.meta;
    if (auctions) {
      this.setState({ auctions: auctions, meta, loading: false });
    }
    if (meta.group) {
      this.setState({ gpData: meta.group });
    }
    if (meta.organization) {
      this.setState({ orgData: meta.organization });
    }
    if (meta.enrolledUsers) {
      this.setState({ enrolledUsers: meta.enrolledUsers });
    }
  }

  async searchAuctions() {
    let { group } = this.state;
    let q = '';
    if (group) {
      q += 'group=' + group;
    }
    if (this.state.input.auction) {
      q += '&auction=' + this.state.input.auction;
    }
    if (this.state.input.fdate) {
      q += '&fdate=' + this.state.input.fdate;
    }
    if (this.state.input.tdate) {
      q += '&tdate=' + this.state.input.tdate;
    }
    if (this.state.input.organization) {
      q += '&organization=' + this.state.input.organization;
    }
    q += '&lang=' + lng;

    this.setState({ loading: true });
    const response = await getGroupedAuctions(q);
    let auctions = response.data;
    let meta = response.meta;
    if (auctions) {
      this.setState({ auctions: auctions, meta, loading: false });
    }
    if (meta.group) {
      this.setState({ gpData: meta.group });
    }
    if (meta.organization) {
      this.setState({ orgData: meta.organization });
    }
    if (meta.enrolledUsers) {
      this.setState({ enrolledUsers: meta.enrolledUsers });
    }
  }

  createDate(dt) {
    return dt ? new Date(dt.replace(/-/g, '/')) : null;
  }

  getImagePopup(active, images) {
    let lightboxImages = [];
    if (images) {
      images.forEach(function (arrayItem) {
        lightboxImages.push({
          url: arrayItem.image,
        });
      });
      this.setState({
        is_active_light_box: active,
        lightboxImages: lightboxImages,
      });
    }
  }

  sortByOrder(data) {
    let result = data;
    if (data.length) {
      result = data.sort((a, b) => a.order - b.order);
    }
    return result;
  }

  toggleFilter = () => {
    this.setState({ isOpen: !this.state.isOpen, show_filter_pop: !this.state.show_filter_pop });
  };

  toggleGrid = () => {
    this.setState({ grid: !this.state.grid });
  };

  render() {
    let { categories, organizations, auctions, catArrs, gpData, now } = this.state;
    let can_show_custom_enroll = false;
    let groupRegEndDate = new Date(this.createDate(gpData.reg_end_date));

    if (
      gpData.is_auctions_grouped &&
      !gpData.is_grouped_enroll &&
      is_logged &&
      groupRegEndDate > now()
    ) {
      can_show_custom_enroll = true;
    }
    auctions = this.sortByOrder(auctions);
    let total_auctions = this.state.meta.total;
    let endDate = this.state.gpData.reg_end_date;
    let endTime = new Date(this.createDate(endDate)).getTime();
    let visit_amount = Number(this.state.gpData.visit_amount);
    let current_lng = localStorage.getItem('I18N_LANGUAGE');
    let page_title = {
      active: i18n.t('active_auctions'),
      previous: i18n.t('previous_auctions'),
      featured: i18n.t('featured_auctions'),
      upcoming: i18n.t('upcoming_auctions'),
      direct: i18n.t('direct_auctions'),
      all: i18n.t('auctions'),
      '': i18n.t('auctions'),
    };

    let vehicle_only = false;
    if (
      auctions.length > 0 &&
      auctions[0].hasOwnProperty('is_vehicle') &&
      auctions[0].is_vehicle === 1
    ) {
      vehicle_only = true;
    }

    return (
      <React.Fragment>
        
        {this.state.loading && (
          <div className="container" id="auction-grouped">
            <AuctionListGrouped />
          </div>
        )}

        {!this.state.loading && (
          <>
            <div className="hero-banner" style={{ padding: '75px 0' }}>
              <div className="hero-content">
                <h1 className="hero-title" style={{ fontSize: '3rem' }}>
                  {current_lng === 'ar' ? gpData.group_name_ar : gpData.group_name}
                </h1>
                <HeaderRowGrp
                  reg_start_date={this.state.gpData.reg_start_date_formatted}
                  enrolledUsers={this.state.enrolledUsers}
                  endTime={endTime}
                />
              </div>
            </div>

            <div className="main-content">
              <div className="container" id="auction-grouped">
                <div className="row mob-padd-9">
                  <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="item2-gl">
                      <div className="showing-auction m-auto">
                        
                      </div>
                      
                      
                      {can_show_custom_enroll && (
                        <div className="row">
                          <div className="col-xl-12 col-lg-12 col-md-12 w-desk-75 m-auto">
                            <div className="pagination mx-2 my-3">
                              <CustomEnroll group={gpData.id} />
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="content overflow-hidden pt-1">
                        <div className="p-1 mb-9">
                          <h5 style={{ textAlign: 'start', padding: '5px' }}>
                            {i18n.t('showing')} {total_auctions} {i18n.t('auctions')}
                          </h5>

                          {auctions.length < 1 && (
                            <div className="alert alert-danger text-center">
                              {i18n.t('no_auctions_found')}
                            </div>
                          )}
                          
                          {!this.state.grid &&
                            auctions.length > 0 &&
                            auctions.map((item, i) => {
                              let key = parseInt(i) + 1;
                              let _data = {
                                screen: 'groupList',
                                auction: item,
                                auctionId: item.id,
                                total_items: auctions.length,
                                company: 'Mzadcom',
                                price: item.start_amount,
                                title: item.title,
                                title_ar: item.title_ar,
                                description: 'Diesel Generators',
                                curr_amount: item.current_amount,
                                end_date: item.end_date_formatted,
                                start_date: item.start_date_formatted,
                                images: item.images,
                                total_views: item.total_views,
                                type: this.state.page_type,
                                can_bid: false,
                                status: item.status,
                                visit_amount: visit_amount,
                                group: this.state.gpData,
                              };
                              return (
                                <AuctionRowGrouped
                                  key={key}
                                  keys={key}
                                  getImagePopup={this.getImagePopup}
                                  {..._data}
                                />
                              );
                            })}

                          <div className="cards-section m-auto">
                            <div className="row">
                              {this.state.grid &&
                                auctions.length > 0 &&
                                auctions.map((item, i) => {
                                  let key = parseInt(i) + 1;
                                  return (
                                    <AuctionCard
                                      key={key}
                                      keys={key}
                                      auction={item}
                                      images={item.images}
                                      getImagePopup={this.getImagePopup}
                                      screen="groupList"
                                      visit_amount={visit_amount}
                                      group={this.state.gpData}
                                      type={this.state.page_type}
                                      auctionId={item.id}
                                      total_items={auctions.length}
                                      company={'Mzadcom'}
                                      price={item.start_amount}
                                      title={item.title}
                                      title_ar={item.title_ar}
                                      curr_amount={item.current_amount}
                                      end_date={item.end_date_formatted}
                                      start_date={item.start_date_formatted}
                                      total_views={item.total_views}
                                      can_bid={true}
                                      status={item.status}
                                    />
                                  );
                                })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {this.state.is_active_light_box && (
          <Lightbox
            images={this.state.lightboxImages}
            onClose={() => {
              this.setState({ is_active_light_box: false });
            }}
          />
        )}
      </React.Fragment>
    );
  }
}